import { Component, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FilePreviewComponent } from '../file-preview/file-preview.component';

@Component({
  selector: 'app-file-picker',
  standalone: true,
  imports: [CommonModule, FilePreviewComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilePickerComponent),
      multi: true
    }
  ],
  template: `
    <div class="flex flex-wrap">
        <app-file-preview (remove)="removeFile($event)" *ngFor="let file of value" [file]="file" class="w-56 h-36 mr-4 mb-4"></app-file-preview>
        <button (click)="fileInput.click()" role="button" type="button" class="text-2xl font-light w-56 h-36 border rounded flex items-center justify-center bg-white active:bg-gray-50 hover:bg-gray-50 cursor-pointer">
          + Bifoga filer
        </button>
    </div>
    <input #fileInput class="invisible h-0 pointer-events-none" type="file" [disabled]="disabled" multiple (change)="onFilePickerChange($event)">
  `,
  styles: [
  ]
})
export class FilePickerComponent implements ControlValueAccessor {
  value: File[] = [];
  disabled = false;
  onChange: any = (value: any) => {};
  onTouched: any = () => {};
  
  async onFilePickerChange(event: Event) {
    const target = event.target as HTMLInputElement;

    if (!target.files) return;

    this.value.push(...Array.from(target.files));
  }
  
  removeFile(file: File) {
    this.value = this.value.filter(f => f !== file);
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
